import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';
import { useMotionPreferences } from '../hooks/useMotionPreferences';
import { TiltCard } from './motion/TiltCard';
import { fadeUp, staggerContainer, viewportOnce } from '../utils/motion';
export function StatsBar() {
  const {
    reduced
  } = useMotionPreferences();
  const {
    t
  } = useLanguage();
  const item = fadeUp(reduced, 24);
  return <section aria-label={t.features.eyebrow} className="relative z-10 -mt-16 w-full px-5 sm:px-8" data-id="element-215" data-mp="1eesdz5bvs2ix">
      <motion.div variants={staggerContainer(0.08)} initial="hidden" whileInView="show" viewport={viewportOnce} className="mx-auto grid max-w-7xl grid-cols-2 gap-4 lg:grid-cols-4" data-id="element-216" data-mp="19ky0wkqs6lst">
        {t.stats.map(stat => <TiltCard key={stat.label} variants={item} maxTilt={7} className="glass group relative overflow-hidden rounded-2xl p-6 text-center transition-[box-shadow,border-color] duration-300 hover:border-magenta/50 hover:shadow-glow-magenta" data-id="element-217" data-mp="vmzkl9swgfao">
            <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-electric to-transparent opacity-70" data-id="element-218" data-mp="3tf2d78oi8kjk" />
            <p className="font-display text-3xl font-black uppercase tracking-tight text-white sm:text-4xl" data-id="element-219" data-mp="3err4rfnmdgno">
              {stat.value}
            </p>
            <p className="mt-2 text-xs font-semibold uppercase tracking-[0.16em] text-white/55" data-id="element-220" data-mp="b8o4pp9092sk">
              {stat.label}
            </p>
          </TiltCard>)}
      </motion.div>
    </section>;
}